/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from 'react';
import ManagedIntegrations from "./ManagedIntegrations"; // eslint-disable-line no-unused-vars

const ManagedIntegrationsContainer = (props) => {
    return(
       <ManagedIntegrations/>
    )
};

export default ManagedIntegrationsContainer;
